<!-- Tab图文信息展示列表：模块头+Tab按钮+图片+标题+内容 -->
<template>
  <div class="content-block">
    <div class="info-list-title">
      <span>{{ title }}</span>
      <label>{{ label }}</label>
      <ul class="list-tab-ul" v-if="tabList.length>0">
        <li v-bind:class="['list-tab-li',params.type==1 ?'active' : '']" v-on:click="selectedAct(1)">产地价格</li>
        <li v-bind:class="['list-tab-li',params.type==2 ?'active' : '']" v-on:click="selectedAct(2)">市场价格</li>

      </ul>
      <router-link :to="'/sghq/jghq?type='+params.type">更多</router-link>
    </div>
    <div class="info-list-content">
      <div class="info-box" >
        <div class="left" v-if="params.type==1 &&chinaSale&&chinaSale.sale==='0'">
          <div class="row" style="flex: 1;display: flex; align-items: center;justify-content: center;">
            <span class="unit">{{chinaSale&&chinaSale.message}}</span>
          </div>
        </div>
        <div class="left" v-else-if="today">
          <p class="title">{{ today.spec.name }}</p>
          <div class="row">
            <span class="label">今日价格</span>
          </div>
          <div class="row">
            <span class="price">{{ today.today_price }}</span>
            <span class="unit">元/{{ today.unit }}</span>
          </div>
          <div class="row b">
            <span class="label">较前日</span>
            <template v-if="today.daily_change>0">
              <span class="value" style="color: #007739;">+{{today.daily_change}}%</span>
              <span class="arr" style="color: #007739;">↑</span>
            </template>
            <template v-else>
              <span class="value"  style="color: #FF5C00;">{{today.daily_change}}%</span>
              <span class="arr" style="color: #FF5C00;">↓</span>
            </template>
          </div>
          <div class="row">
            <span class="label">{{ today.type==1?'产地':'市场' }}</span>
            <span class="value">{{ today.dependency }}</span>
          </div>
          <div class="row">
            <span class="label">日期</span>
            <span class="value">{{ today.date_time }}</span>
          </div>
        </div>
        <div class="right">
          <div class="line-echart" id="avocadoEcharts"></div>
        </div>
        <div class="mask" v-if="loading"><img src="../../assets/loading.png" class="loading" /></div>
      </div>
    </div>
  </div>
</template>

<script>
import Line01 from '../chart/Line01'
import {GridComponent} from 'echarts/components'

let echarts = require('echarts/lib/echarts')
// 引入柱状图
require('echarts/lib/chart/line')
require('echarts/lib/component/title')
require('echarts/lib/component/tooltip')
require('echarts/lib/component/legend')

echarts.use([GridComponent])

export default {
  name: 'ChartTabList02',
  components: {'chart-line-01': Line01},
  props: {
    title: {
      type: String,
      default: ''
    },
    titleLength: {
      type: Number,
      default: 16
    },
    label: {
      type: String,
      default: ''
    },
    col: {
      type: String,
      default: '3'
    },
    count: {
      type: String,
      default: '4'
    }
  },
  data () {
    return {
      msg: '',
      chinaSale:null,
      celWidth: 'calc(100%/' + this.col + ')',
      tabList: [{title: '产地价格', id: 1}, {title: '市场价格', id: 2}],
      defaultTab: 1,
      infoList: [],
      today: undefined,
      echart: undefined,
      params: {
        type: 2
      },
      loading: false
    }
  },
  created: function () {
    // this.queryPage(this.defaultTab)
    this.fetchData()
  },
  methods: {
    fetchTodayPrice () {
      return new Promise((resolve, reject) => {
        this.$dataApi.getPriceData(this.params).then(res => {
          console.log(res.data)
          if (res.code !== 1) {
            reject(res)
          }
          const {data} = res
          this.today = data.info
          this.chinaSale=data.chinaSale
          this.$nextTick(() => {
            this.initEcharts(data.chartData.xAxis, data.chartData.yAxis)
            this.loading = false
          })
        })
      })
    },
    fetchData () {
      this.loading = true
      this.fetchTodayPrice()
    },
    initEcharts (xAxis, yAxis) {
      const option = {
        title: {
          text: '价格走势'
        },
        tooltip: {
          trigger: 'axis',
          formatter: function (params) {
            let str = ''
            params.forEach(item => {
              str += item.name + '<br />' + item.value + '元/公斤</br>'
            })
            return str
          }
        },
        xAxis: {
          type: 'category',
          data: xAxis
        },
        yAxis: {
          name: '元/公斤',
          type: 'value'
        },
        grid: {
          left: '5%',
          right: '5%',
          bottom: '10%'
        },
        series: [
          {
            itemStyle: {
              normal: {
                color: '#477931', // 改变折线点的颜色
                lineStyle: {
                  color: '#477931' // 改变折线颜色
                }
              }
            },
            data: yAxis,
            type: 'line'
          }
        ]
      }
      this.echart = echarts.init(document.getElementById('avocadoEcharts'))
      this.echart.setOption(option)
    },
    selectedAct: function (id) {
      this.params.type = id
      this.fetchData()
    }
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.info-box {
  display: flex;
  flex-direction: row;
  height: 240px;
  position: relative;
}
.info-box .mask {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(255,255,255,.8);
  display: flex;
  align-items: center;
  justify-content: center;
}
.info-box .mask .loading {
  width: 30px;
  height: 30px;
  animation: rotate 2s infinite linear;
  opacity: .6;
}
@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.info-box .left {
  width: 225px;
  padding: 24px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.info-box .left .title {
  color: #353535;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
}
.info-box .right {
flex: 1;
  height: 100%;
  padding: 24px 0;
  box-sizing: border-box;
}
.info-box .left .row .label {
  color: #999;
  font-size: 12px;
  font-weight: 400;
  line-height: normal;
  margin-right: 10px;
}
.info-box .left .row .value {
  color: #666;
  font-size: 12px;
  font-weight: 400;
}
.info-box .left .row.b .value,.info-box .left .row.b .arr{
  font-weight: 700;
}

.info-box .left .row .price {
  color: #FF5C00;
  font-size: 24px;
  font-weight: 700;
}
.info-box .left .row .unit {
  color: #FF5C00;
  font-size: 14px;
  font-weight: 700;
}

.info-box .right {
  margin-left: 16px;
}

.line-echart {
  width: 100%;
  height: 100%;
}

h1,
h2 {
  font-weight: normal;
}

a {
  color: #42b983;
  text-decoration: none;
}

.list-tab-ul {
  display: block;
  position: absolute;
  top: 7px;
  left: 240px;
  heith: 40px;
  list-style-type: none;
  padding: 0;
//background:red;
}

.list-tab-li {
  float: left;
  margin: 0px 4px 0px 0px;
  height: 30px;
  width: 80px;
  color: #000;
  font-size: 12px;
  font-weight: 600;
  line-height: 30px;
  text-align: center;
  cursor: pointer;
  padding: 0;
}

.list-tab-ul .active {
  color: #ffffff;
  background: var(--color7);
}

.list-container {
  display: flex;
  flex-wrap: wrap;
}

.list-container-cell {
  box-sizing: border-box;
  height: 170px;
  background: #fff;
  border: 0px solid red;
}

.list-container-cell a {
  display: flex;
  box-sizing: border-box;
  padding: 8px;
  margin: 4px;
  background-color: #fff;
  border: 1px solid #ddd;

}

.list-container-cell a:hover {
  border: 1px solid var(--color6);
  box-shadow: 0px 0px 1px 0px var(--color6);
}

.list-container-cell a:hover .base-info-title {
  color: var(--color6);
}

.cell-left-info {
  width: 50%;
}

.cell-right-info {
  width: 50%;
  background: #fff;
}

.list-container-cell .cell-base-info {
  position: relative;
  height: 80px;
  color: #000;
  background-color: #fff;
  padding-right: 0px;
}

.cell-base-info .base-info-title {
  position: relative;
  height: 30px;
  font-size: 14px;
  font-weight: 600;
  line-height: 30px;
}

.cell-base-info .base-info-label {
  position: relative;
  height: 40px;
  font-size: 12px;
  line-height: 20px;
  color: #888;
  padding-left: 18px;
  background-image: url(./../../assets/location.png);
  background-size: 17px 17px;
  background-repeat: no-repeat;
  background-position: 0px 3px;
}

.cell-base-info .base-info-label2 {
  position: relative;
  height: 20px;
  padding-left: 18px;
  font-size: 12px;
  line-height: 20px;
  color: #888;
//background:red; background-image: url(./../../assets/clock.png);
  background-size: 14px 14px;
  background-repeat: no-repeat;
  background-position: 0px 2px;
}

.cell-base-info .base-info-image {
  position: absolute;
  top: 0px;
  right: 0px;
  height: 70px;
  width: 70px;
  color: #000;
  border-radius: 10px;
  background-color: #eee;
  padding-right: 70px;
  background-size: 70px auto;
  background-repeat: no-repeat;
  background-position: right top;
}

.list-container-cell .cell-col-info {
  height: 50px;
  padding-top: 5px;
  margin-top: 15px;
  background-color: #fff;
  border-top: 1px solid #ddd;
}

.cell-col-info table {
  width: 100%;
  height: 40px;
  text-align: center;
}

.cell-col-info table th {
  font-size: 12px;
  color: #888;
  font-weight: 400;
  border-left: 1px solid #ddd;
}

.cell-col-info table th:first-child {
  border-left: 0px;
}

.cell-col-info table td {
  font-size: 16px;
  font-weight: 600;
  color: #000;
  border-left: 1px solid #ddd;
}

.cell-col-info table td:first-child {
  border-left: 0px;
}

.cell-col-info table td span {
  padding: 2px;
  margin-left: 4px;
  font-size: 12px;
  background: orange;
  color: #fff;
}

.cell-col-info .price {
  color: red;
}

</style>



// WEBPACK FOOTER //
// src/components/block/ChartTabList02.vue